import { render, staticRenderFns } from "./conferenceAll.vue?vue&type=template&id=bf06d78e"
import script from "./conferenceAll.vue?vue&type=script&lang=js"
export * from "./conferenceAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports